export default "__VITE_ASSET__064d5c5e__"